import React from 'react';

import PhoneInput from 'common/Form/components/PhoneInput';
import EmailInput from 'common/Form/components/EmailInput';

import { Wrapper } from '../UI';

/**
 * @typedef {{
 *  defaultCountry: string,
 * }} ContactProps
 */

/** @type {React.FC<ContactProps>} */
const Contact = ({ defaultCountry }) => (
  <Wrapper className="contact-form__wrapper">
    <EmailInput name="customerInfo.email" required />
    <PhoneInput
      localName="customerInfo.phoneNumber.local"
      prefixName="customerInfo.phoneNumber.prefix"
      defaultCountry={defaultCountry}
    />
  </Wrapper>
);

export default Contact;
